import OrderAddRequest, {
  OrderAddRequestCargoOrderRide,
  OrderAddRequestRideSeqItem,
  OrderAddRequestRideWaypoint,
  OrderAddRequestRideWaypointGroup,
  OrderAddRequestRideWaypointMeta,
  OrderAddRequestRideWaypointMetaCargoItem,
  OrderAddRequestRideWaypointMetaCargoItems,
  OrderAddRequestSequenceOrder,
} from "../../../api/raily/order/add/order-add-request";
import OrderAddParams, {
  OrderAddParamsCargoOrderRide,
  OrderAddParamsRideSeqItem,
  OrderAddParamsRideWaypoint,
  OrderAddParamsRideWaypointGroup,
  OrderAddParamsRideWaypointMeta,
  OrderAddParamsRideWaypointMetaCargoItem,
  OrderAddParamsRideWaypointMetaCargoItems,
  OrderAddParamsSequenceOrder,
} from "./order-add-params";

const createSequenceOrder = (
  order: OrderAddParamsSequenceOrder,
): OrderAddRequestSequenceOrder => {
  switch (order) {
    case OrderAddParamsSequenceOrder.ANY:
      return OrderAddRequestSequenceOrder.ANY;
    case OrderAddParamsSequenceOrder.STRICT:
      return OrderAddRequestSequenceOrder.STRICT;
  }
};

const createCargoSubject = (
  subject: OrderAddParamsRideWaypointMetaCargoItem,
): OrderAddRequestRideWaypointMetaCargoItem => {
  return {
    id: subject.uuid,
  };
};

const createCargo = (
  items: OrderAddParamsRideWaypointMetaCargoItems,
): OrderAddRequestRideWaypointMetaCargoItems => {
  return {
    subjects: items.subjects.map(createCargoSubject),
  };
};

const createWaypointMeta = (
  meta: OrderAddParamsRideWaypointMeta,
): OrderAddRequestRideWaypointMeta => {
  return {
    cargoEnter: createCargo(meta.cargoEnter),
    cargoExit: createCargo(meta.cargoExit),
    id: meta.uuid,
  };
};

const createWaypoint = (
  waypoint: OrderAddParamsRideWaypoint,
): OrderAddRequestRideWaypoint => {
  return {
    displayName: waypoint.displayName,
    haltingTime: waypoint.haltingTime,
    lat: waypoint.lat,
    lon: waypoint.lon,
    meta: createWaypointMeta(waypoint.meta),
    time: waypoint.time,
  };
};

const createWaypointGroup = (
  group: OrderAddParamsRideWaypointGroup,
): OrderAddRequestRideWaypointGroup => {
  return {
    seq: group.seq.map(createWaypoint),
    sequenceOrder: createSequenceOrder(group.sequenceOrder),
  };
};

const createSequenceItem = (
  item: OrderAddParamsRideSeqItem,
): OrderAddRequestRideSeqItem => {
  if ((item as OrderAddParamsRideWaypointGroup).seq !== undefined) {
    return createWaypointGroup(item as OrderAddParamsRideWaypointGroup);
  } else {
    return createWaypoint(item as OrderAddParamsRideWaypoint);
  }
};

const createRide = (
  ride: OrderAddParamsCargoOrderRide,
): OrderAddRequestCargoOrderRide => {
  return {
    seq: ride.seq.map(createSequenceItem),
    sequenceOrder: createSequenceOrder(ride.sequenceOrder),
  };
};

const create = (params: OrderAddParams): OrderAddRequest => {
  return {
    cargoTaxiContractId: params.cargoTaxiContractUuid,
    externalId: params.externalId,
    railyRide: createRide(params.railyRide),
    targetTaxiId: params.targetTaxiUuid,
    assumeDispatcherId: params.assumeDispatcherUuid,
  };
};

const orderAddParamsFactory = {
  create,
};

export default orderAddParamsFactory;
